/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Client API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    Onboarding,
    OnboardingFromJSON,
    OnboardingToJSON,
    UserMeWithBalance,
    UserMeWithBalanceFromJSON,
    UserMeWithBalanceToJSON,
    VersionedConfig,
    VersionedConfigFromJSON,
    VersionedConfigToJSON,
} from './';

/**
 * 
 * @export
 * @interface ConfigAndUserBindSlugResult
 */
export interface ConfigAndUserBindSlugResult {
    /**
     * 
     * @type {string}
     * @memberof ConfigAndUserBindSlugResult
     */
    projectId: string;
    /**
     * 
     * @type {VersionedConfig}
     * @memberof ConfigAndUserBindSlugResult
     */
    config?: VersionedConfig;
    /**
     * 
     * @type {Onboarding}
     * @memberof ConfigAndUserBindSlugResult
     */
    onboardBefore?: Onboarding;
    /**
     * 
     * @type {UserMeWithBalance}
     * @memberof ConfigAndUserBindSlugResult
     */
    user?: UserMeWithBalance;
}

export function ConfigAndUserBindSlugResultFromJSON(json: any): ConfigAndUserBindSlugResult {
    return {
        'projectId': json['projectId'],
        
        'config': !exists(json, 'config') ? undefined : VersionedConfigFromJSON(json['config']),
        
        'onboardBefore': !exists(json, 'onboardBefore') ? undefined : OnboardingFromJSON(json['onboardBefore']),
        
        'user': !exists(json, 'user') ? undefined : UserMeWithBalanceFromJSON(json['user']),
    };
}

export function ConfigAndUserBindSlugResultToJSON(value?: ConfigAndUserBindSlugResult): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'projectId': value.projectId,
        
        'config': VersionedConfigToJSON(value.config),
        
        'onboardBefore': OnboardingToJSON(value.onboardBefore),
        
        'user': UserMeWithBalanceToJSON(value.user),
    };
}


